/**
 * Извлекает Kinescope video id из URL.
 *
 * Поддерживает:
 *   https://kinescope.io/{id}                — обычный
 *   https://kinescope.io/embed/{id}           — embed (из <iframe>)
 *   https://kinescope.io/v/{id}               — player
 *   https://kinescope.io/{id}/{privateToken}  — Private link (берём первый сегмент)
 * + допускает query string и hash после id.
 */
export const getKinescopeId = (url: string): string | undefined => {
  if (!url.includes('kinescope.io/')) {
    return undefined
  }

  const tail = url.split('kinescope.io/')[1] ?? ''
  const cleanPath = tail.split('?')[0].split('#')[0]
  const segments = cleanPath.split('/').filter(Boolean)

  // Пропускаем известные префиксы (embed, v) — id идёт следом.
  const startIdx = segments[0] === 'embed' || segments[0] === 'v' ? 1 : 0
  const id = segments[startIdx]

  return id || undefined
}
